// extracted by mini-css-extract-plugin
module.exports = {"tasks":"Tasks_tasks__1FMD1","welcome":"Tasks_welcome__2wcOx"};